module.exports = __webpack_public_path__ + "static/img/wancheng.5130a15c.png";